import { emphasisSchema, inlineCodeSchema } from '@milkdown/kit/preset/commonmark';
import { strikethroughSchema } from '@milkdown/kit/preset/gfm';
import { Plugin, PluginKey } from '@milkdown/kit/prose/state';
import { $prose } from '@milkdown/kit/utils';

import { codeInlineCompatMark, emCompatMark, strikethroughCompatMark } from './marks';

const PLATFORM_PERSIST_MARK_NORMALIZER_META = 'platformPersistMarkNormalizer';

const platformPersistMarkNormalizerKey = new PluginKey('platformPersistMarkNormalizer');

/**
 * Rewrites collab marks to names Milkdown toolbar/commands expect, plus Platform persist names.
 * Italic: `em` (legacy Y.js) → `emphasis` (Crepe). Do not rewrite `emphasis` → `em`.
 * Inline code / strikethrough still persist as Platform names.
 * Register only when collaboration is enabled.
 */
export const platformPersistMarkNormalizer = $prose((ctx) => {
  const inlineCodeType = inlineCodeSchema.type(ctx);
  const codeInlineType = codeInlineCompatMark.type(ctx);
  const emphasisType = emphasisSchema.type(ctx);
  const emType = emCompatMark.type(ctx);
  const strikeThroughType = strikethroughSchema.type(ctx);
  const strikethroughType = strikethroughCompatMark.type(ctx);

  return new Plugin({
    key: platformPersistMarkNormalizerKey,
    appendTransaction(transactions, _oldState, newState) {
      if (transactions.some((txn) => txn.getMeta(PLATFORM_PERSIST_MARK_NORMALIZER_META))) {
        return null;
      }

      const txn = newState.tr;
      let changed = false;

      newState.doc.descendants((node, pos) => {
        if (!node.isText) {
          return;
        }

        const from = pos;
        const to = pos + node.nodeSize;

        if (node.marks.some((mark) => mark.type === inlineCodeType)) {
          txn.removeMark(from, to, inlineCodeType);
          txn.addMark(from, to, codeInlineType.create());
          changed = true;
        }

        if (node.marks.some((mark) => mark.type === emType)) {
          txn.removeMark(from, to, emType);
          txn.addMark(from, to, emphasisType.create());
          changed = true;
        }

        if (node.marks.some((mark) => mark.type === strikeThroughType)) {
          txn.removeMark(from, to, strikeThroughType);
          txn.addMark(from, to, strikethroughType.create());
          changed = true;
        }
      });

      if (!changed) {
        return null;
      }

      txn.setMeta(PLATFORM_PERSIST_MARK_NORMALIZER_META, true);

      return txn;
    },
  });
});
